import { pdfjs } from "react-pdf";

import "./pdf-worker-setup";

/**
 * Returns the number of pages in a PDF file.
 * Best-effort: returns 0 if parsing fails so callers can treat it as a non-blocking fallback.
 */
export const countPdfPages = async (file: File): Promise<number> => {
  const arrayBuffer = await file.arrayBuffer();
  const pdf = await pdfjs.getDocument({ data: arrayBuffer }).promise;
  return pdf.numPages;
};
